import { useCallback } from 'react';
import { CatalogItem, SerializedKitAsset } from '../../../../redux/api/fymAPI.types';
import { kitAssetLibraryFile } from './libraryGroups';
import { PostLibraryFileOptions, usePostLibraryFile } from './usePostLibraryFile';

/**
 * "Post it" on a kit asset of `item` (the Studio result, the Assets tab): hands the file to the
 * Composer and opens it. Does nothing when `canPostKitAsset` is false.
 */
export function usePostKitAsset(
  item: CatalogItem
): (asset: SerializedKitAsset, options?: PostLibraryFileOptions) => void {
  const postFile = usePostLibraryFile();

  return useCallback(
    (asset: SerializedKitAsset, options?: PostLibraryFileOptions) => {
      const file = kitAssetLibraryFile(asset);
      if (file !== null) {
        postFile(item, file, options);
      }
    },
    [item, postFile]
  );
}
